import axios from 'axios';
import React, {useEffect, useState, useRef } from 'react';
import '../../styles/global.css'; // Seu CSS global
import { useParams, useNavigate } from 'react-router-dom';
import { WhatsApp, Mail, MailOutline } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

function Votacao() {
    const {idvotacao} = useParams();
    const {idassembleia} = useParams();
    //console.log(idvotacao, idassembleia);
    const navigate = useNavigate();
    const loggedIn = sessionStorage.getItem('loggedIn');
    const [isLoading, setIsLoading] = useState(false);
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).format(now).replace(/\//g, '/').replace(',','');
    const uuid = crypto.randomUUID();
    const [votacao, setVotacao] = useState({
        IdVotacao: idvotacao !== undefined && parseInt(idvotacao) ? idvotacao : 0,
        IdAssembleia: idassembleia !== undefined && parseInt(idassembleia) ? idassembleia : 0,
        vtcTitulo: '',
        vtcDescricao: '',
        vtcTipoDeVotacao: '',
        vtcSecreto: 0,
        vtcOpcoes: '',
        vtcDataInicio: '',
        vtcDataFinal: '',
        vtcPosicao: '',
        vtcComunicar: 0,
        vtcComentar: 0,
        vtcConvocados: '',
        vtcParticipantes: '',
        vtcStatus: 1,
        vtcCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'desconhecido',
        vtcCriadoEm: customFormatDate,
        vtcAlteradoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'desconhecido',
        vtcAlteradoEm: customFormatDate,
        vtcCodigoGUID: uuid
    });
    const [assembleia, setAssembleia] = useState(null);
    // auto-resize textarea for votacao description
    const textareaRef = useRef(null);
    // auto-resize handler for textarea
    const handleInput = (e) => {
        const textarea = textareaRef.current;
        textarea.style.height = 'auto'; // Reseta a altura para recalcular
        textarea.style.height = `${textarea.scrollHeight}px`; // Define com base no conteúdo
    };
    //envia para login se o usuário não estiver logado
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);

    //se houver um id de votação, busca os dados da votação correspondente
    useEffect(() => {
        if (idvotacao !== undefined && parseInt(idvotacao) > 0) {
            setIsLoading(true);
            const dados = {
                IdVotacao: idvotacao !== undefined && parseInt(idvotacao) > 0 ? idvotacao : 0
            }
            // console.log(dados);
            axios
            .post(
                process.env.REACT_APP_API_URL +
                '/routes.php?metodo=obtemVotacoes',
                JSON.stringify(dados),
                {
                    headers: {
                        'X-Access-Token': tokenAPI,
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                }
            )
            .then(response => {
                if(response.data) {
                    setVotacao(response.data[0]);
                    setIsLoading(false);
                } else {
                    alert('Votação não encontrada.');
                    setIsLoading(false);
                    navigate('/Votacoes');
                }
                
            })
            .catch(error => {
                console.error('Erro ao buscar dados da votação:', error);
                alert('Erro ao buscar dados da votação.');
                setIsLoading(false);
                navigate('/Votacoes');
            });
        }
        // Aqui você pode adicionar lógica para buscar dados da votação, se necessário
    }, [idvotacao]);

    //volta para a página anterior
    function handleFecharModal() {
        window.history.back();
    }

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    //pessoas convocadas e pessoas presentes
    const [pessoas, setPessoas] = useState([]);
    const [pessoasConvocadas, setPessoasConvocadas] = useState([]);
    const [pessoasParticipantes, setPessoasParticipantes] = useState([]);
    //carrega pessoas
    useEffect(() => {
        setIsLoading(true);
        axios
        .get(
        process.env.REACT_APP_API_URL +
        '/routes.php?metodo=obterAssociadosAtivos',
        { headers: { 
            "X-Access-Token": tokenAPI,
            "Content-Type": "application/json; charset=UTF-8"
        } }
        )
        .then(response => {
        setPessoas(response.data)
        setIsLoading(false);
        })
        .catch(error => {
        let ret = error.message;
        setIsLoading(false);
        if (ret.includes("401")) {
            console.log("token inválido!")
        }
        })
    }, []);
    // Determina se TODAS as pessoas estão selecionadas atualmente
    const todasSelecionadas = pessoasConvocadas.length === pessoas.length;
    // Função para selecionar ou deselecionar todo mundo
    const toggleSelecionarTodos = () => {
        if (pessoasConvocadas.length === pessoas.length) {
        // Se todas já estavam selecionadas, esvazia o estado
            setPessoasConvocadas([]);
            setPessoasParticipantes([]);
        } else {
        // Se não, coloca todas as pessoas da lista no estado
            setPessoasConvocadas([...pessoas]);
            setPessoasParticipantes([...pessoasConvocadas]);
        }
    };
    // Seleciona ou deseleciona uma pessoa específica
    const toggleConvocaPessoa = (pessoa) => {
        setPessoasConvocadas(prevState => {
            const estaConvocado = prevState.some((p) => p.IdPessoa === pessoa.IdPessoa);
            if (estaConvocado) {
                return prevState.filter((p) => p.IdPessoa !== pessoa.IdPessoa);
            } else {
                return [...prevState, pessoa];
            }
        });
    };
    // a propriedade assConvocados tem separado por ; os IdPessoas convocadas salvos na base, e deve ser usada para inicializar o estado pessoasConvocadas quando o componente for montado.
    useEffect(() => {
        if (votacao && votacao.vtcConvocados) {
            const convocados = votacao.vtcConvocados.split(';').map(id => id.trim());
            const pessoasConvocadasInicial = pessoas.filter(pessoa => convocados.includes(pessoa.IdPessoa.toString()));
            setPessoasConvocadas(pessoasConvocadasInicial);
        }
    }, [votacao, pessoas]);

    // Deetermina se TODAS as pessoas estavam presentes
    const todasParticipantes = pessoasParticipantes.length === pessoasConvocadas.length;
    // função que marca presença de todos ou nenhuma presença
    const toggleMarcarTodosParticipantes = () => {
        if (pessoasParticipantes.length === pessoasConvocadas.length) {
            setPessoasParticipantes([]);
        } else {
            setPessoasParticipantes([...pessoasConvocadas]);
        }
    };
    // Marca ou desmarca a presença de uma pessoa específica
    const togglePresencaPessoa = (pessoa) => {
        setPessoasParticipantes(prevState => {
            const estaPresente = prevState.some((p) => p.IdPessoa === pessoa.IdPessoa);
            if (estaPresente) {
                return prevState.filter((p) => p.IdPessoa !== pessoa.IdPessoa);
            } else {
                return [...prevState, pessoa];
            }
        });
    };
    // a propriedade assParticipantes tem separado por ; os IdPessoas presentes salvos na base, e deve ser usada para inicializar o estado pessoasParticipantes quando o componente for montado.
    useEffect(() => {
        if (votacao && votacao.vtcParticipantes) {
            const presentes = votacao.vtcParticipantes.split(';').map(id => id.trim());
            const pessoasParticipantesInicial = pessoasConvocadas.filter(pessoa => presentes.includes(pessoa.IdPessoa.toString()));
            setPessoasParticipantes(pessoasParticipantesInicial);
        }
    }, [votacao, pessoasConvocadas]);
    // Fim do gerenciamento de presença das pessoas convocadas

    const [votosRegistrados, setVotosRegistrados] = useState([]);
    useEffect(() => {
            axios
            .post(process.env.REACT_APP_API_URL 
                + '/routes.php?metodo=ObtemVotosRegistrados', { IdVotacao: votacao.IdVotacao },{
                    headers: {
                    'X-Access-Token': 'ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00',
                    'Content-Type': 'application/json'
                    }
                }
            )
            .then(response => {
                if(response.data){
                    setVotosRegistrados(response.data);
                } else {
                    alert('Erro ao buscar os votos registrados: ' + JSON.stringify(response.data));
                }
            })
            .catch(error => {
                alert('Erro ao buscar os votos registrados: ' + error.message);
            });
    }, [votacao]);

    //recebe o nome e formata, devolve em string
    const formatarNome = (nome) => {
        let nomeFormatado = '';
            const arrayNome = nome.trim().split(' ');
            if (arrayNome.length < 3) {
                nomeFormatado = nome; 
            } else {
                nomeFormatado = arrayNome[0];
                
                for (let i = 1; i < arrayNome.length - 1; i++) {
                    if (arrayNome[i].length > 2 
                        && i < arrayNome.length
                        && arrayNome[i].toUpperCase().trim() !== 'DOS'
                        && arrayNome[i].toUpperCase().trim() !== 'DA'
                        && arrayNome[i].toUpperCase().trim() !== 'DE'
                        && arrayNome[i].toUpperCase().trim() !== 'DO'
                        && arrayNome[i].toUpperCase().trim() !== 'DAS'
                        && arrayNome[i].toUpperCase().trim() !== 'DOS') {
                        nomeFormatado += ' ' + arrayNome[i].charAt(0) + '.';
                    } else {
                        nomeFormatado += ' ' + arrayNome[i];
                    }
                }
                nomeFormatado += ' ' + arrayNome[arrayNome.length - 1];
            }
        return nomeFormatado;
    };

    //SALVAR VOTAÇÃO
    const handleSalvarVotacao = (event) => {
        event.preventDefault();
        if (votacao.vtcTitulo && votacao.vtcTitulo.trim() === '') {
            alert('O título da votação não pode estar vazio.');
            return;
        } else if (votacao.vtcDescricao && votacao.vtcDescricao.trim() === '') {
            alert('A descrição da votação não pode estar vazia.');
            return;
        } else if (votacao.vtcOpcoes && votacao.vtcOpcoes.trim() === '') {
            alert('As opções da votação não podem estar vazias.');
            return;
        }

        if (pessoasConvocadas.length > 0) {
            const convocadosString = pessoasConvocadas.map(pessoa => pessoa.IdPessoa).join(';');
            votacao.vtcConvocados = convocadosString;
        } else {
            votacao.vtcConvocados = '';
        }
        
        if (votosRegistrados.length > 0) {
            const participantesString = votosRegistrados.map(pessoa => pessoa.IdPessoa).join(';');
            votacao.vtcParticipantes = participantesString;
        } else {
            votacao.vtcParticipantes = '';
        }

        // console.log('Pessoas Convocadas:', pessoasConvocadas);
        // console.log('Votos Registrados:', votosRegistrados);
        // console.log('Pessoas Participantes:', pessoasParticipantes);
        // console.log('Votação a ser salva:', votacao);return;

        // lógica para salvar nova votacao ou alterar se já existir um id de votação
        if (votacao.IdVotacao && parseInt(votacao.IdVotacao) > 0) {
            // lógica para alterar a votação existente
            axios
            .post(process.env.REACT_APP_API_URL 
                + '/routes.php?metodo=atualizarVotacao', 
                votacao,{
                    headers: {
                    'X-Access-Token': 'ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00',
                    'Content-Type': 'application/json'
                    }
                }
            )
            .then(response => {
                alert(response.data.message);
                if (parseInt(votacao.vtcComunicar) === 1) {
                    let comunicar = window.confirm('Comunicar os Convocados?');
                    if (comunicar) {
                        handleComunicarConvocados();
                    }
                }
                window.history.back();
            })
            .catch(error => {
                alert('Erro ao atualizar a votação: ' + error.message);
            });
        } else {
            // lógica para salvar nova votação
            axios
            .post(process.env.REACT_APP_API_URL 
                + '/routes.php?metodo=CriarVotacao', 
                votacao,{
                    headers: {
                    'X-Access-Token': 'ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00',
                    'Content-Type': 'application/json'
                    }
                }
            )
            .then(response => {
                alert(response.data);
                window.history.back();
            })
            .catch(error => {
                alert('Erro ao criar a votação: ' + error);
            });
        }
    };

    const handleComunicarConvocados = async () => {
        //console.log(pessoasConvocadas); return;
        for (const convocado of pessoasConvocadas) {
            await new Promise(resolve => setTimeout(resolve, 3000));
            enviarEmailConvocado(convocado);
        }
    };

    const enviarEmailIndividual = async (pessoa) => {
        try {
            if (!window.confirm(`Deseja enviar um email para ${pessoa.pesNome}?`)) {
                return;
            }
            await enviarEmailConvocado(pessoa);
            alert(`Email enviado para ${pessoa.pesNome}`);
        } catch (error) {
            alert(`Erro ao enviar email para ${pessoa.pesNome}: ${error.message}`);
        }
    };

    const enviarEmailConvocado = async (convocado) => {
        try {
            //console.log("antes da pausa")
            //preciso que esse loop faça uma pausa aqui nesse ponto por 2 segundos
            //await new Promise(resolve => setTimeout(resolve, 3000));
            //console.log("depois da pausa");

            // lógica para comunicar cada participante
            var corpoEmail = `
            <div style="margin: 0px; width: 100vw; height: 100vh; color: white; background-color: black; font-family: Arial, Helvetica, sans-serif;">
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <img width="200px" src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="logoMGBE"/>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        Caro ${formatarNome(convocado.pesNome)}, 
                        ${votacao.vtcPosicao === 'ANDAMENTO' ? 'você está convidado a participar da votação.' : ''}
                        ${votacao.vtcPosicao === 'PENDENTE' ? 'em breve você poderá participar dessa votação.' : ''}
                        ${votacao.vtcPosicao === 'FINALIZADO' ? 'a votação foi finalizada.' : ''}
                        ${votacao.vtcPosicao === 'CANCELADO' ? 'a votação foi cancelada.' : ''}
                        ${votacao.vtcPosicao === 'AUDITANDO' ? 'os resultados estão sendo auditados.' : ''}
                        <br />
                        
                    
                        <br/><br />
                        ${votacao.assDescricao && votacao.assDescricao !== '' ? `Votação da Assembleia: ${votacao.assDescricao} <br />` : ''} 
                        <br/>
                        <br/>
                        Votação: ${votacao.IdVotacao}
                        <br /><br />
                        Título: ${votacao.vtcTitulo ? votacao.vtcTitulo : ''}
                        <br /><br />
                        ${
                            votacao.vtcDescricao 
                            && 
                            votacao.vtcPosicao === 'ANDAMENTO' ? `Descrição: ${votacao.vtcDescricao}` 
                            : 
                            votacao
                            &&
                            votacao.vtcPosicao === 'FINALIZADO' ? `VOTAÇÃO FINALIZADA` : 
                            votacao
                            &&
                            votacao.vtcPosicao === 'CANCELADO' ? `VOTAÇÃO CANCELADA` : 
                            votacao
                            &&
                            votacao.vtcPosicao === 'AUDITANDO' ? `VOTAÇÃO EM AUDITORIA` : 
                            ''
                        }
                        <br />
                        <br />
                        ${votacao.vtcDataInicio && (votacao.vtcPosicao === 'ANDAMENTO' || votacao.vtcPosicao === 'PENDENTE') ? `Início da votação: ${new Date(votacao.vtcDataInicio).toLocaleDateString('pt-BR', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                        })}` : ''}
                        <br />
                        ${votacao.vtcDataFinal && (votacao.vtcPosicao === 'ANDAMENTO' || votacao.vtcPosicao === 'PENDENTE') ? `Fim da votação: ${new Date(votacao.vtcDataFinal).toLocaleDateString('pt-BR', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                        })}` : ''}
                        <br />
                        <br />
                        ${
                            votacao.vtcPosicao === 'PENDENTE' ? `Posição Da Votação: NÃO INICIADA` : 
                            votacao.vtcPosicao === 'ANDAMENTO' ? `Posição Da Votação: EM ANDAMENTO` : ''
                            //votacao.vtcPosicao === 'FINALIZADO' ? 'FINALIZADO' :
                            //votacao.vtcPosicao === 'AUDITANDO' ? 'AUDITANDO' : 
                            //votacao.vtcPosicao === 'CANCELADO' ? 'CANCELADO' : 
                            //'Não disponível'
                        }
                        <br />
                        <br />
                        ${votacao.vtcPosicao === 'ANDAMENTO' ? 'Seu voto é muito importante!' : ''}
                        <br />
                        <br />
                        ${votacao.vtcPosicao === 'ANDAMENTO' ? 
                        `<b><a href="https://www.brasilextremos.com.br/#/Votar/${votacao.IdVotacao}/${convocado.pesCodigoGUID}/email">CLIQUE AQUI PARA VOTAR OU ACOMPANHAR</a></b>`
                        : votacao.vtcPosicao === 'PENDENTE' ? 
                        'A votação ainda não foi iniciada, logo receberá novo comunicado..' 
                        : votacao.vtcPosicao === 'FINALIZADO' ? 
                        `<b><a href="https://www.brasilextremos.com.br/#/Resultado/${votacao.IdVotacao}">CLIQUE AQUI PARA VER O RESULTADO</a></b>`
                        : ''}
                        <br />
                        <br />
                    </div>
                </div>
                <hr />
                <div style="font-size: 12px; color: #c1bbbb; padding: 10px;">
                    O conteúdo desse e-mail é destinado apenas ao destinatário.<br />
                    Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                    A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                    Agradecemos sua compreensão e cooperação.<br />
                    <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                </div>
            </div>
            `;
            const dadosEmail = {
                "email": convocado.pesEmail,
                "assunto": 'MGBE - Convocação para Votar',
                "mensagem": corpoEmail
            };
            axios
            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                dadosEmail,
                {
                    headers: 
                    {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            )
            .then(response => {
                console.log('Resposta do envio de email para ' + convocado.pesEmail + ':', response.data);
                if (response.data.message === 'E-mail enviado com sucesso!') {
                    console.log('Email enviado para ' + convocado.pesEmail + " com sucesso!\n" + response.data.message);
                    salvarLog('Email enviado para ' + convocado.pesEmail + " com sucesso!\n" + response.data.message);
                } else {
                    console.log('Erro ao enviar email para ' + convocado.pesEmail + "!\n" + response.data.message);
                    salvarLog('Erro ao enviar email para ' + convocado.pesEmail + "!\n" + response.data.message);
                }
            })
            .catch(error => {
                alert(`Houve um erro ao enviar o email`);
                salvarLog('Houve um erro ao enviar o email para ' + convocado.pesEmail + "!\n" + error);
            });
        } catch (error) {
            alert('Erro ao enviar email para o convocado: ' + error.message);
        }
    };

    const enviarWhatsAppIndividual = (convocado) => {
        try {
            //console.log(convocado); return;
            if (window.confirm(`Deseja enviar a mensagem via WhatsApp para ${formatarNome(convocado.pesNome)}?`)) {
                const celularFormatado = `+55${convocado.pesCelular.replace(' ', '').replace('-', '').replace('(', '').replace(')', '')}`;
                const nomeFormatado = formatarNome(convocado.pesNome);
                let texto = "";
                if (votacao.vtcPosicao === 'ANDAMENTO') {
                    texto = `Olá ${nomeFormatado}, você foi convocado para participar da votação:\n ${votacao.vtcTitulo}. \n\nPor favor, acesse o link abaixo para votar. \n\n${`https://www.brasilextremos.com.br/#/Votar/${votacao.IdVotacao}/${convocado.pesCodigoGUID}/whatsapp`}\n\nSeu voto é muito importante!\n\nGestão MGBE.`;
                } else if (votacao.vtcPosicao === 'FINALIZADO') {
                    texto = `Olá ${nomeFormatado}, a votação:\n${votacao.vtcTitulo}\nfoi encerrada! \nAgradecemos sua participação.\n\nVocê pode acompanhar os resultados no portal:\n${`https://www.brasilextremos.com.br/#/Resultado/${votacao.IdVotacao}`}\n\nGestão MGBE.`;
                } else if (votacao.vtcPosicao === 'CANCELADO') {
                    texto = `Olá ${nomeFormatado}, a votação:\n${votacao.vtcTitulo}\nfoi cancelada! \nAgradecemos sua atenção.\n\nGestão MGBE.`;
                } else if (votacao.vtcPosicao === 'AUDITANDO') {
                    texto = `Olá ${nomeFormatado}, a votação:\n${votacao.vtcTitulo}\nestá em auditoria! \nAgradecemos sua atenção.\n\nGestão MGBE.`;
                }
                if (texto !== "") {
                    window.open(`https://wa.me/${celularFormatado}?text=${encodeURIComponent(texto)}`, '_blank');
                }
            }
        } catch (error) {
            alert('Erro ao enviar mensagem via WhatsApp para o convocado: ' + error.message);
        }
    };

    function salvarLog(mensagem) {
        const log = {
        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        logTipo: "Votacao - Email Atualização",
        logModulo: mensagem,
        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
        logCriadoEm: new Date().toISOString(),
        logCodigoGUID: crypto.randomUUID()
        };
        axios                    
        .post(process.env.REACT_APP_API_URL 
            + '/routes.php?metodo=novoLog', 
            log, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            console.log(response.data[0].mensagem);
            //setSalvarLog(false);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error);
            //setSalvarLog(false);
        })
    }
    //obtem dados da assembleia
    useEffect(() => {
        if (idassembleia > 0){
            axios
            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obterAssembleias',
                {
                    "IdAssembleia": idassembleia
                },
                {
                    headers: {
                        "X-Access-Token": "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00",
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }
            )
            .then(response => {
                if (response.data) {
                    setAssembleia(response.data);
                }
            });
        }
    }, [idassembleia]);

    //console.log(pessoasConvocadas);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* fechar */}
                    <div className='d-flex w100 mt1 flex-column text-align-left'>
                        <div className='text-align-left w80 fs16'>
                            <button
                                className="buttonModalPadraoLaranja fs11"
                                onClick={handleFecharModal}>Fechar
                            </button>
                        </div>
                    </div>

                    <div>
                        <div>
                            <div className="headerMain">
                                <label className='labelTitulo' >CADASTRO VOTAÇÃO</label>
                            </div>
                            {/* Informações da assembleia */}
                            <div className="d-flex w100 flex-column tdAlignLeft pb4">
                                {assembleia && assembleia.length > 0 && (
                                    <>
                                    <div className="text-align-left divForm fs11">
                                        <label>ASSEMBLEIA: {assembleia[0].assDescricao}</label>
                                    </div>
                                    <div className="text-align-left divForm fs11">
                                        <label>Data: {assembleia[0].assConvocacao}</label>
                                    </div>
                                    <div className="text-align-left divForm fs11">
                                        <label>Chamadas: 1a. {assembleia[0].assPrimeiraConvocacao} 2a. {assembleia[0].assSegundaConvocacao}</label>
                                    </div>
                                    </>
                                )}
                            </div>
                            <div className="d-flex w100 flex-column tdAlignLeft pb4">
                                {/* Titulo da votacao */}
                                <div className="d-flex flex-row divForm">
                                    <div className="w100">
                                        <div className="text-align-left divForm fs11">
                                            <label>TITULO</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <textarea
                                                defaultValue={votacao.vtcTitulo}
                                                onChange={(e) => setVotacao({...votacao, vtcTitulo: e.target.value})}
                                                className=" fs11 w100 text-align-left"
                                                required
                                                maxLength={255}
                                                name="vtcTitulo"
                                                id="vtcTitulo"
                                                ref={textareaRef}
                                                onInput={handleInput}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                }}
                                            />
                                        </div>
                                        {votacao && votacao.vtcTitulo && votacao.vtcTitulo.length}/255
                                    </div>
                                </div>
                                {/* Descricao da votacao */}
                                <div className="d-flex flex-row divForm">
                                    <div className="w100">
                                        <div className="text-align-left divForm fs11">
                                            <label>DESCRIÇÃO</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <textarea
                                                defaultValue={votacao.vtcDescricao}
                                                onChange={(e) => setVotacao({...votacao, vtcDescricao: e.target.value})}
                                                className="pt1 pb1 p1 fs11 w100 text-align-left"
                                                required
                                                maxLength={2048}
                                                name="vtcDescricao"
                                                id="vtcDescricao"
                                                ref={textareaRef}
                                                onInput={handleInput}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                }}
                                            />
                                        </div>
                                        {votacao.vtcDescricao.length}/2048
                                    </div>
                                </div>
                                {/* Tipo de votação é um input de seleção com opções: SIM_NÃO e MULTIPLA ESCOLHA */}
                                {/* Secreto é um input de seleção com opções: Selecione (valor ""), SIM (valor 1) e NÃO (valor 0) */}
                                <div className="d-flex flex-row divForm">
                                    {/* vtcTipoDeVotacao */}
                                    <div className="w100">
                                        <div className="text-align-left divForm fs11">
                                            <label>TIPO</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <select
                                                defaultValue={votacao.vtcTipoDeVotacao}
                                                onChange={(e) => setVotacao({...votacao, vtcTipoDeVotacao: e.target.value})}
                                                className="pt1 pb1 p1 fs11 w100 text-align-left"
                                                required
                                                name="vtcTipoDeVotacao"
                                                id="vtcTipoDeVotacao"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                }}
                                            >
                                                <option value="" selected={votacao.vtcTipoDeVotacao === ""}>Selecione</option>
                                                <option value="SIM_NAO" selected={votacao.vtcTipoDeVotacao === "SIM_NAO"}>SIM / NÃO</option>
                                                <option value="MULTIPLA_ESCOLHA" selected={votacao.vtcTipoDeVotacao === "MULTIPLA_ESCOLHA"}>MULTIPLA ESCOLHA</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* vtcSecreto */}
                                    <div className="w100">
                                        <div className="text-align-left divForm fs11">
                                            <label>SECRETO</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <select
                                                defaultValue={votacao.vtcSecreto}
                                                onChange={(e) => setVotacao({...votacao, vtcSecreto: e.target.value})}
                                                className="pt1 pb1 p1 fs11 w100 text-align-left"
                                                required
                                                name="vtcSecreto"
                                                id="vtcSecreto"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                }}
                                            >
                                                <option value="" selected={votacao.vtcSecreto === ""}>Selecione</option>
                                                <option value="1" selected={votacao.vtcSecreto === "1"}>SIM</option>
                                                <option value="0" selected={votacao.vtcSecreto === "0"}>NÃO</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* Opções é um input de texto para serem colocados as opções possíveis na hora de votar */}
                                <div className="d-flex flex-row divForm">
                                    <div className="w100">
                                        <div className="text-align-left divForm fs11">
                                            <label>OPÇÕES</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <textarea
                                                defaultValue={votacao.vtcOpcoes}
                                                onChange={(e) => setVotacao({...votacao, vtcOpcoes: e.target.value})}
                                                className="pt1 pb1 p1 fs11 w100 text-align-left"
                                                required
                                                maxLength={512}
                                                name="vtcOpcoes"
                                                id="vtcOpcoes"
                                                ref={textareaRef}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                }}
                                            />
                                        </div>
                                        {votacao.vtcOpcoes.length}/512
                                    </div>
                                </div>
                                {/* Data e Hora de inicio são inputs para selecionar a data e hora de início da votação, salvar no formato DD/MM/yyyy HH:mm */}
                                {/* Data de Fim é um input do tipo date para selecionar a data de término da votação, salvar no fomato DD/MM/yyyy */}
                                <div className={`d-flex divForm ${windowWidth < 768 ? 'flex-column' : 'flex-row'}`}>
                                    {/* vtcDataInicio */}
                                    <div className="w100">
                                        <div className="text-align-left divForm fs11">
                                            <label>INÍCIO</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <input
                                                type="datetime-local"
                                                defaultValue={votacao.vtcDataInicio}
                                                onChange={(e) => setVotacao({...votacao, vtcDataInicio: e.target.value})}
                                                className="pt1 pb1 p1 fs11 w100 text-align-left"
                                                required
                                                name="vtcDataInicio"
                                                id="vtcDataInicio"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {/* vtcDataFinal */}
                                    <div className="w100">
                                        <div className="text-align-left divForm fs11">
                                            <label>FINAL</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <input
                                                type="datetime-local"
                                                defaultValue={votacao.vtcDataFinal}
                                                onChange={(e) => setVotacao({...votacao, vtcDataFinal: e.target.value})}
                                                className="pt1 pb1 p1 fs11 w100 text-align-left"
                                                required
                                                name="vtcDataFinal"
                                                id="vtcDataFinal"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* vtcPosicao é um input de seleção para escolher a posição da votação entre as opções: PENDENTE, ANDAMENTO, AUDITANDO, FINALIZADO ou CANCELADO */}
                                {/* vtcComunicar é um input de seleção para escolher se a comunicação deve ser enviada: SIM ou NÃO */}
                                <div className="d-flex flex-row divForm">
                                    {/* vtcComunicar */}
                                    <div className="w100">
                                        <div className="text-align-left divForm fs11">
                                            <label>COMUNICAR</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <select
                                                defaultValue={votacao.vtcComunicar}
                                                onChange={(e) => setVotacao({...votacao, vtcComunicar: e.target.value})}
                                                className="pt1 pb1 p1 fs11 w100 text-align-left"
                                                required
                                                name="vtcComunicar"
                                                id="vtcComunicar"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                }}
                                            >
                                                <option value="" selected={votacao.vtcComunicar === ""}>Selecione</option>
                                                <option value="1" selected={votacao.vtcComunicar === "1"}>SIM</option>
                                                <option value="0" selected={votacao.vtcComunicar === "0"}>NÃO</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* vtcComentar é um input de select para indicar se os participantes podem comentar na votação */}
                                    <div className="w100">
                                        <div className="text-align-left divForm fs11">
                                            <label>COMENTAR</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <div className="w100">
                                                <select
                                                    defaultValue={votacao.vtcComentar}
                                                    onChange={(e) => setVotacao({...votacao, vtcComentar: e.target.value})}
                                                    className="pt1 pb1 p1 fs11 w100 text-align-left"
                                                    required
                                                    name="vtcComentar"
                                                    id="vtcComentar"
                                                    style={{
                                                        width: '100%',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    <option value="" selected={votacao.vtcComentar === ""}>Selecione</option>
                                                    <option value="1" selected={votacao.vtcComentar === "1"}>SIM</option>
                                                    <option value="0" selected={votacao.vtcComentar === "0"}>NÃO</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                

                                {/* vtcPosicao */}
                                
                                <div className="d-flex flex-row mt2 text-align-center">
                                    <div className="text-align-left divForm fs11">
                                        <label>POSIÇÃO</label>
                                    </div>
                                </div>
                                <div className="d-flex flex-row divForm">
                                    <div className="w70 d-flex" style={{ verticalAlign: 'top', alignSelf: 'flex-start', alignItems: 'flex-start' }}>
                                        <select
                                            defaultValue={votacao.vtcPosicao}
                                            onChange={(e) => setVotacao({...votacao, vtcPosicao: e.target.value})}
                                            className="pt1 pb1 p1 fs11 w100 text-align-left"
                                            required
                                            name="vtcPosicao"
                                            id="vtcPosicao"
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                            }}
                                        >
                                            <option value="" selected={votacao.vtcPosicao === ""}>Selecione</option>
                                            <option value="PENDENTE" selected={votacao.vtcPosicao === "PENDENTE"}>PENDENTE</option>
                                            <option value="ANDAMENTO" selected={votacao.vtcPosicao === "ANDAMENTO"}>ANDAMENTO</option>
                                            <option value="AUDITANDO" selected={votacao.vtcPosicao === "AUDITANDO"}>AUDITANDO</option>
                                            <option value="FINALIZADO" selected={votacao.vtcPosicao === "FINALIZADO"}>FINALIZADO</option>
                                            <option value="CANCELADO" selected={votacao.vtcPosicao === "CANCELADO"}>CANCELADO</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Convocados e Participantes */}
                                <div className="d-flex flex-row mt2 text-align-center">
                                    <div className="text-align-left divForm fs11 w100 text-align-center">
                                        <label><b>CONVOCADOS & PRESENTES</b></label>
                                    </div>
                                </div>
                                <hr className="w100" />
                                <div className="d-flex flex-row divForm">
                                    {/* Pessoas Convocadas */}
                                    <div className="w50 d-flex" style={{ verticalAlign: 'top', alignSelf: 'flex-start', alignItems: 'flex-start' }}>
                                        {/* lista das pessoas com sinalização de convocados */}
                                        <div className="w100">
                                            <div className="text-align-center divForm fs10 w100">
                                                <label>CONVOCADOS</label>
                                            </div>
                                            <div className="text-align-center divForm fs11 w100">
                                            {pessoasConvocadas && pessoasConvocadas.filter(pessoa => {
                                                if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                    return pessoa;
                                                }
                                            }).length}
                                            </div>
                                            {/* botão para selecionar todos da lista de pessoas */}
                                            <div className="text-align-center mt1">
                                                <button
                                                    onClick={toggleSelecionarTodos}
                                                    style={{
                                                    padding: '10px 20px',
                                                    marginBottom: '15px',
                                                    cursor: 'pointer',
                                                    backgroundColor: todasSelecionadas ? '#ffcdd2' : '#c8e6c9',
                                                    border: '1px solid #999',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold'
                                                    }}
                                                    >
                                                    {todasSelecionadas ? 'DESMARCAR TODOS' : 'CONVOCAR TODOS'}
                                                </button>
                                            </div>
                                            {/* lista de pessoas e convocados */}
                                            <div className="d-flex flex-column divForm w100 fs09" style={{ backgroundColor: '#cbc7c7', padding: '5px', borderRadius: '5px' }}>
                                                {pessoas ?
                                                    pessoas
                                                .filter(pessoa => {
                                                    if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                        return pessoa;
                                                    }
                                                })
                                                .map(pessoa => {
                                                    const estaConvocado = pessoasConvocadas.some((p) => p.IdPessoa === pessoa.IdPessoa);
                                                    return (
                                                        <div key={pessoa.IdPessoa}
                                                            style={{ borderRadius: '5px', padding: '5px', cursor: 'pointer', width: '100%', backgroundColor: estaConvocado ? '#507455' : '#5c5a5a' }} >
                                                            <div 
                                                                onClick={() => toggleConvocaPessoa(pessoa)}
                                                                style={{ padding: '3px', textAlign: 'left', paddingTop: '5px' }}>
                                                                <b>{pessoa.pesNome}</b> 
                                                                {pessoa.pesEmail ? (
                                                                    <>
                                                                        <br /><span style={{ fontStyle: 'italic', fontSize: '0.8em' }}>{pessoa.pesEmail.split('@')[0]}</span>
                                                                        <br /><span style={{ fontStyle: 'italic', fontSize: '0.7em' }}>@{pessoa.pesEmail.split('@')[1]}</span>
                                                                    </>
                                                                ) : ''}
                                                            </div>
                                                            <div style={{ display: !estaConvocado ? 'none' : 'block', width: '97%', textAlign: 'center', borderRadius: '5px', paddingBottom: '5px', backgroundColor: '#f2eded', margin: '10px ', padding: '5px' }}>
                                                                {pessoa.pesEmail && (
                                                                    <Tooltip title="Enviar email de convocação">
                                                                        <label style={{ cursor: 'pointer', marginRight: '15px' }}>
                                                                            <MailOutline style={{ color: '#a3a7e6', fontSize: '30px' }} onClick={() => enviarEmailIndividual(pessoa)} />
                                                                        </label>
                                                                    </Tooltip>
                                                                )}
                                                                {pessoa.pesCelular && (
                                                                    <Tooltip title="Enviar mensagem via WhatsApp">
                                                                        <label style={{ cursor: 'pointer', marginRight: '15px' }}>
                                                                            <WhatsApp style={{ color: '#25D366', fontSize: '30px', }} onClick={() => enviarWhatsAppIndividual(pessoa)} />
                                                                        </label>
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                            <div style={{ width: '100%', textAlign: 'right', paddingBottom: '5px' }}>
                                                                {estaConvocado && <span> (Convocado)</span>}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                : <div>Nenhum convocado encontrado.</div>
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    {/* Pessoas Pariticipantes */}
                                    <div className="w50 d-flex" style={{ verticalAlign: 'top', alignSelf: 'flex-start', alignItems: 'flex-start' }}>
                                        {/* lista das pessoas com sinalização de presença */}
                                        <div className="w100">
                                            <div className="text-align-center divForm fs10 w100">
                                                <label>VOTOS REGISTRADOS</label>
                                            </div>
                                            <div className="text-align-center divForm fs11 w100">
                                            {votosRegistrados && votosRegistrados.length}
                                            </div>
                                            {/* botão para marcar presença para todos da lista */}
                                            <div className="text-align-center">
                                                <button
                                                    onClick={toggleMarcarTodosParticipantes}
                                                    style={{
                                                    padding: '10px 20px',
                                                    marginBottom: '15px',
                                                    cursor: 'pointer',
                                                    backgroundColor: todasParticipantes ? '#ffcdd2' : '#c8e6c9',
                                                    border: '1px solid #999',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold', 
                                                    // display: pessoasConvocadas !== '' && pessoasConvocadas.length > 0 ? 'inline-block' : 'none'
                                                    display: 'none'
                                                    }}
                                                    >
                                                    {todasParticipantes ? 'DESMARCAR TODOS' : 'TODOS VOTARAM'}
                                                </button>
                                            </div>
                                            {/* lista de votos */}
                                            <div className="d-flex flex-column divForm w100 fs09" style={{ backgroundColor: '#cbc7c7', padding: '5px', borderRadius: '5px' }}>
                                                {pessoasConvocadas && pessoasConvocadas.length > 0 ?
                                                    pessoasConvocadas
                                                    .filter(pessoa => {
                                                        if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                            return pessoa;
                                                        }
                                                    })
                                                    .map(pessoa => {
                                                        const participante = votosRegistrados.some((p) => p.IdPessoa === pessoa.IdPessoa);
                                                        return (
                                                            <div key={pessoa.IdPessoa}
                                                                style={{ borderRadius: '5px', border: '1px solid #bbb6b6', padding: '5px', width: '100%', color: participante ? 'green' : 'red', backgroundColor: participante ? '#c8e6c9' : '#ffcdd2' }}>
                                                                <div style={{ padding: '3px', textAlign: 'left', paddingTop: '5px' }}>
                                                                    <b>{pessoa.pesNome}</b> 
                                                                    {pessoa.pesEmail ? (
                                                                    <>
                                                                        <br /><span style={{ fontStyle: 'italic', fontSize: '0.8em' }}>{pessoa.pesEmail.split('@')[0]}</span>
                                                                        <br /><span style={{ fontStyle: 'italic', fontSize: '0.7em' }}>@{pessoa.pesEmail.split('@')[1]}</span>
                                                                    </>
                                                                ) : ''}
                                                                </div>
                                                                <div style={{ width: '100%', textAlign: 'right', paddingBottom: '5px' }}>
                                                                    ({participante ? 'Votou' : 'Pendente'})
                                                                </div>
                                                                
                                                            </div>
                                                        )
                                                    })
                                                : 
                                                <div>Nenhum voto encontrado.</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* fim da lista de votos */}
                                {/* botao salvar */}
                                <div className="d-flex flex-row mt2 w100 text-align-center">
                                    {parseInt(sessionStorage.pesAdmin) === 1  ? (
                                    <div className='text-align-left mt2 mb2 divForm fs11'>
                                        <button onClick={(event) => handleSalvarVotacao(event)}
                                        className='buttonModalPadrao pt1 pb1 w100 fs11'
                                        type="submit">
                                            SALVAR VOTAÇÃO
                                        </button>
                                    </div> ) : ('')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default Votacao;